import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../../utils';

export const fetch = async (query: { ProductId: number; Warehouse: string; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, Page, Warehouse, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `/InventoryEnquiry/Product/${ProductId}/Warehouse/${Warehouse}/InTransit/Import`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        StockingQuantityInTransitImports: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.StockingQuantityInTransitImports) {

            return {
              records: result.StockingQuantityInTransitImports.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
